import get from 'lodash.get';

const getWLCookieDomain = (rootState) => get(rootState, 'config.common.authtkt.wl_cookie_domain');

export default getWLCookieDomain;
